<template>
  <div id="main">
    <!-- ======= Services Section (include testominal here) ======= -->
    <section id="services" class="services">
      <div class="container">
        <div class="section-title">
          <h2>Services</h2>
          <p>
            Jotweb offers quality and professional services with free one month
            support after service rendered. My customers satisfaction is my
            highest priority.
          </p>
        </div>

        <div class="row">
          <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up">
            <div class="icon"><i class="icofont icofont-computer"></i></div>
            <h4 class="title"><a href="">Web design</a></h4>
            <p class="description">
              I offer a responsive and well customized websites based on
              customers' request(s).
            </p>
          </div>
          <div
            class="col-lg-4 col-md-6 icon-box"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div class="icon">
              <i class="icofont icofont-chart-bar-graph"></i>
            </div>
            <h4 class="title"><a href="">Data Analysis</a></h4>
            <p class="description">
              Data speaks! Do you have some data you want to understand by well
              detailed exploration and visualization. You are at the right
              place.
            </p>
          </div>
          <div
            class="col-lg-4 col-md-6 icon-box"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div class="icon"><i class="icofont icofont-earth"></i></div>
            <h4 class="title"><a href="">E-commerce</a></h4>
            <p class="description">
              offers creation of an ecommerce store and integration of payment
              gateway.
            </p>
          </div>
          <div
            class="col-lg-4 col-md-6 icon-box"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div class="icon"><i class="icofont icofont-image"></i></div>
            <h4 class="title"><a href="">UX/UI Design</a></h4>
            <p class="description">
              offers UI/UX design for website, products or store.
            </p>
          </div>
          <div
            class="col-lg-4 col-md-6 icon-box"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <div class="icon"><i class="icofont icofont-settings"></i></div>
            <h4 class="title"><a href="">Debugging</a></h4>
            <p class="description">
              I will fix any bugs on your website based on the aforementioned
              skills in the <emp>Skill</emp> section
            </p>
          </div>
          <div
            class="col-lg-4 col-md-6 icon-box"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            <div class="icon"><i class="icofont icofont-tasks-alt"></i></div>
            <h4 class="title"><a href="">Help & Advice</a></h4>
            <p class="description">
              I'm open to offer advice and support for free on any of my
              services.
            </p>
          </div>
        </div>
      </div>
    </section>
    <!-- End Services Section -->

    <!-- ======= Testimonials Section ======= -->
    <section id="testimonials" class="testimonials section-bg">
      <div class="container">
        <div class="section-title">
          <h2>Testimonials</h2>
        </div>

        <div class="testimonials-carousel">
          <carousel :autoplay="true" :nav="false">
            <div class="testimonial-item" data-aos="fade-up">
              <p>
                <i class="bx bxs-quote-alt-left quote-icon-left"></i>
                Proin iaculis purus consequat sem cure digni ssim donec
                porttitora entum suscipit rhoncus. Accusantium quam, ultricies
                eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.
                <i class="bx bxs-quote-alt-right quote-icon-right"></i>
              </p>
              <img
                src="assets/img/testimonials/testimonials-1.jpg"
                class="testimonial-img"
                alt=""
              />
              <h3>Saul Goodman</h3>
              <h4>Ceo &amp; Founder</h4>
            </div>

            <div
              class="testimonial-item"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <p>
                <i class="bx bxs-quote-alt-left quote-icon-left"></i>
                Export tempor illum tamen malis malis eram quae irure esse
                labore quem cillum quid cillum eram malis quorum velit fore eram
                velit sunt aliqua noster fugiat irure amet legam anim culpa.
                <i class="bx bxs-quote-alt-right quote-icon-right"></i>
              </p>
              <img
                src="assets/img/testimonials/testimonials-2.jpg"
                class="testimonial-img"
                alt=""
              />
              <h3>Sara Wilsson</h3>
              <h4>Designer</h4>
            </div>

            <div
              class="testimonial-item"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <p>
                <i class="bx bxs-quote-alt-left quote-icon-left"></i>
                Enim nisi quem export duis labore cillum quae magna enim sint
                quorum nulla quem veniam duis minim tempor labore quem eram duis
                noster aute amet eram fore quis sint minim.
                <i class="bx bxs-quote-alt-right quote-icon-right"></i>
              </p>
              <img
                src="assets/img/testimonials/testimonials-3.jpg"
                class="testimonial-img"
                alt=""
              />
              <h3>Jena Karlis</h3>
              <h4>Store Owner</h4>
            </div>

            <div
              class="testimonial-item"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <p>
                <i class="bx bxs-quote-alt-left quote-icon-left"></i>
                Fugiat enim eram quae cillum dolore dolor amet nulla culpa
                multos export minim fugiat minim velit minim dolor enim duis
                veniam ipsum anim magna sunt elit fore quem dolore labore illum
                veniam.
                <i class="bx bxs-quote-alt-right quote-icon-right"></i>
              </p>
              <img
                src="assets/img/testimonials/testimonials-4.jpg"
                class="testimonial-img"
                alt=""
              />
              <h3>Matt Brandon</h3>
              <h4>Freelancer</h4>
            </div>

            <div
              class="testimonial-item"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <p>
                <i class="bx bxs-quote-alt-left quote-icon-left"></i>
                Quis quorum aliqua sint quem legam fore sunt eram irure aliqua
                veniam tempor noster veniam enim culpa labore duis sunt culpa
                nulla illum cillum fugiat legam esse veniam culpa fore nisi
                cillum quid.
                <i class="bx bxs-quote-alt-right quote-icon-right"></i>
              </p>
              <img
                src="assets/img/testimonials/testimonials-5.jpg"
                class="testimonial-img"
                alt=""
              />
              <h3>John Larson</h3>
              <h4>Entrepreneur</h4>
            </div>
          </carousel>
        </div>
      </div>
    </section>
    <!-- End Testimonials Section -->

    <a name="" id="" class="btn btn-primary" href="/contact" role="button"
      >Go to Next Section</a
    >
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import carousel from "vue-owl-carousel";

export default {
  name: "Services",
  components: {
    carousel
  }
};
</script>
